import React from "react"
import WeatherCountry from "./WeatherCountry"

const CountryInfo = ({countriesList,targetCountry}) => {
    return(
        <section className="country-info">
            {
            countriesList.filter(country => {
                return country.name.common === targetCountry
            }).map(country => {
                return(
                    <section className="main-country__info">
                        <header>
                            <h2>{country.name.common}</h2>
                        </header>
                        {
                            country.capital ? 
                            country.capital.length > 2 ?
                                <>
                                    <p><strong>Capital:</strong></p>
                                    <ul>
                                        {
                                            country.capital.map(capital => {
                                                return <li>{capital}</li>
                                            })
                                        }
                                    </ul>
                                </> :
                                <p><strong>Capital:</strong> {country.capital}</p> :
                            <>
                                <p><strong>Capital:</strong> No specified</p>
                            </>
                        }
                        <p><strong>Population:</strong> {country.population}</p>
                        <WeatherCountry 
                                country_name={country.name.common}/>
                        <article className="main-country__languages">
                            <p><strong>Languages</strong></p>
                            <ul>
                                {
                                    country.languages ?
                                    Object.values(country.languages).map(language => <li>{language}</li>) :
                                    <li>Not specified</li>
                                }
                            </ul>
                        </article>
                        <span className="main-flag">{country.flag}</span>  
                    </section>
                )
            })  
            }   
        </section>
    )
}

export default CountryInfo